(function () {
  if (window.SwipePadsScrollReveal) return;

  var SECTION_SELECTOR = '.sp_scroll_section';
  var VISIBLE_CLASS = 'sp_scroll_section--visible';

  /**
   * @param {HTMLElement} section
   */
  function initSection(section) {
    if (section.dataset.scrollRevealInit === 'true') return;
    section.dataset.scrollRevealInit = 'true';

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      section.classList.add(VISIBLE_CLASS);
      return;
    }

    var threshold = 0.15;
    if (section.dataset.scrollRevealThreshold !== undefined) {
      threshold = parseFloat(section.dataset.scrollRevealThreshold);
      if (Number.isNaN(threshold)) threshold = 0.15;
    }

    var rootMargin = section.dataset.scrollRevealRootMargin || '0px';

    var observer = new IntersectionObserver(
      function (entries) {
        var entry = entries[entries.length - 1];
        if (!entry || !entry.isIntersecting) return;

        section.classList.add(VISIBLE_CLASS);
        observer.unobserve(section);
      },
      { threshold: threshold, rootMargin: rootMargin }
    );

    observer.observe(section);
  }

  function init() {
    var sections = document.querySelectorAll(SECTION_SELECTOR);
    for (var i = 0; i < sections.length; i += 1) {
      var section = sections[i];
      if (section instanceof HTMLElement) {
        initSection(section);
      }
    }
  }

  window.SwipePadsScrollReveal = { init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
